export default {
	subtitle: "Webhooks on Transactions",
	path: "webhooks_transactions",
	paragraphs: [
		"We always send webhook notifications for all transactions whenever there is a status change. The following webhook will always be the first notification you receive — assuming everything goes as expected. It is triggered when the incoming funds are received in the FacilitaPay bank account created exclusively for your use, or when there is sufficient available balance to initiate a transaction such as payouts or conversions between internal accounts.",
	],
	request: {
		method: "POST",
		payloads: [
			{
				title: "Notification",
				content: {
					"notification": {
						"type": "identified",
						"transaction_id": "UUID",
						"secret": "the value you received"
					}
				}
			}
		]
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksTransactions.js